import Analysis from 'domain/entity/analysis';
import { Result } from 'domain/types';
import { CreateAnalysisDataCriteria } from 'use-case/analysis/analysisCriteria';
import { CreateAnalysisClient } from 'use-case/analysis/create/createAnalysisClient';

export type CreateAnalysisResult = Result<Analysis>;
export type CreateAnalysis = (criteria: CreateAnalysisDataCriteria) => Promise<CreateAnalysisResult>;

export const createAnalysisUseCase = (createAnalysisClient: CreateAnalysisClient): CreateAnalysis => (
    criteria: CreateAnalysisDataCriteria
): Promise<CreateAnalysisResult> => createAnalysisClient(criteria);
